// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorDialog_error__3Bi2G"};